import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { GlobalStyle } from "./globalStyle";
import 'simplebar/dist/simplebar.min.css'; // ✅ CORRECT import

console.log = () => {};
console.warn = () => {};
console.error = () => {};

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>
);
